import {
  SET_USERNAME,
  SET_AUTH_TOKEN,
  SET_REFRESH_TOKEN,
  SET_AUTH_TOKEN_EXPIRES,
  SET_USER_INFO,
  UPDATE_KID,
  RESET_AUTH_STATE
} from "./mutation-types";

export default {
  [SET_USERNAME](state, id) {
    state.username = id;
  },
  [SET_AUTH_TOKEN](state, token) {
    state.authToken = token;
  },
  [SET_REFRESH_TOKEN](state, token) {
    state.refreshToken = token;
  },
  [SET_AUTH_TOKEN_EXPIRES](state, ttl) {
    state.authTokenExpiresIn = ttl;
  },
  [SET_USER_INFO](state, oUserInfo) {
    state.userInfo = Object.assign({}, state.userInfo, oUserInfo);
  },
  [UPDATE_KID](state, oKidInfo) {
    const kidIdx = state.kids.findIndex(kid => kid.id === oKidInfo.id);
    if (kidIdx !== -1) {
      state.kids.splice(kidIdx, 1, oKidInfo);
    } else {
      state.kids.push(oKidInfo);
    }
  },
  [RESET_AUTH_STATE](state, inDefaultState) {
    Object.assign(state, inDefaultState);
  }
};
